import { fetchPostAuthToken } from '@/service/api';
import { localStg } from '@/utils/storage';

export const whiteRequest = ['/developer-platform/api/user/login', '/developer-platform/api/auth/token'];
export const dateCenterList = ['/developer-platform/api/dataCenter/list'];
export const tokenExpirationCode = [1009000000, 1009000004];

// 数据大屏的不接口提示
const noErrorTipList = [
  'developer-platform/api/product/statistics/deviceRegionalDistribution',
  'developer-platform/api/product/statistics/topPopularProduct',
  'developer-platform/api/product/statistics/topProductDeviceNum',
  'developer-platform/api/product/statistics/topPopularProductFunction',
  'developer-platform/api/product/statistics/countDevice',
  'developer-platform/api/product/statistics/countDeviceMsg',
  'developer-platform/api/product/statistics/countProduct',
  'developer-platform/api/application/statistics/countApplication'
];

/**
 * 大屏接口不提示错误
 *
 * @param url
 * @returns
 */
export const isNoErrorTip = (url: string) => {
  return noErrorTipList.some(item => url.includes(item));
};

const changeableRequestList = [
  '/developer-platform/api/device/record/message',
  '/developer-platform/api/device/query/list',
  '/developer-platform/api/firmware/ota/task/board/query',
  '/developer-platform/api/product/function/list',
  '/developer-platform/api/firmware/ota/task/create',
  '/developer-platform/api/firmware/ota/task/query/list',
  '/developer-platform/api/firmware/ota/task/remove',
  '/developer-platform/api/firmware/ota/task/query/detail',
  '/developer-platform/api/firmware/ota/task/devicesRetryOta',
  '/developer-platform/api/firmware/ota/task/devicesOtaNow',
  '/developer-platform/api/firmware/ota/task/products/common',
  '/developer-platform/api/firmware/ota/task/versionList',
  '/developer-platform/api/device/query/detail',
  '/developer-platform/api/device/record/connect',
  '/developer-platform/api/device/log/list',
  '/developer-platform/api/device/log/download',
  ...noErrorTipList
];

/**
 * 过滤页面可手动切换的请求
 *
 * @param url
 * @returns
 */
export const filterChangeableRequest = (url: string) => {
  return changeableRequestList.some(item => url.includes(item));
};

export const setAuthorizationToken = (token: string) => {
  localStg.set('authorizationToken', token);
};

export const getAuthorizationToken = () => {
  return localStg.get('authorizationToken');
};

export const updateAuthorizationToken = async () => {
  const { data, error } = await fetchPostAuthToken();

  if (!error) {
    setAuthorizationToken(data);
  }

  return { error };
};

export const getCurrentDataCenter = () => {
  return localStg.get('currentDataCenter');
};

export const getUserDataService = () => {
  const list = localStg.get('dataCenterList');
  if (list?.length) {
    return list.find(item => item.id === localStg.get('personInfo')?.dataCenterId);
  }

  return null;
};

export const getIsNoCrossService = () => {
  return localStg.get('isNoCrossService');
};

export const userSelectServeUrl = () => {
  return localStg.get('userSelectServe')?.current ? '' : localStg.get('userSelectServe')?.appApiAddress;
};
